import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetOnboardingJourneyFilesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetOnboardingJourneyFilesQuery = { __typename?: 'Query', onboardingJourneyLookup: { __typename?: 'OnboardingJourneyLookup', exists: boolean, unfinished: boolean, journeyId?: string | null, sessionReference?: string | null }, onboardingJourneyState?: { __typename?: 'OnboardingJourneyStateView', journeyId: string, jobs: Array<{ __typename?: 'OnboardingJourneyJobEvidence', jobId: string, sourceId: string, sourceVersion: number, state: Types.OnboardingJourneyJobState }> } | null, onboardingJourneyOutsideUploads: Array<{ __typename?: 'OnboardingOutsideUpload', fileName: string, sourceId: string, sourceVersion: number, uploadedAt: Types.TDateISO }>, tenant?: { __typename?: 'TenantStateData', onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', importedAt?: Types.TDateISO | null, occurredAt: Types.TDateISO, reviewAreas: Array<Types.OnboardingReviewArea>, fileName: string, sourceId?: string | null, sourceVersion?: number | null }> } | null };

export type GetOnboardingWelcomeQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetOnboardingWelcomeQuery = { __typename?: 'Query', tenant?: { __typename?: 'TenantStateData', onboardingSetup: Types.OnboardingSetupStage, onboardingTraining: Types.OnboardingTrainingStatus, contractedProducts: string } | null, onboardingJourneyLookup: { __typename?: 'OnboardingJourneyLookup', exists: boolean, unfinished: boolean, journeyId?: string | null }, myOnboardingWelcomePreference: { __typename?: 'OnboardingWelcomePreference', snoozedUntil?: Types.TDateISO | null, isSnoozed: boolean, isDismissed: boolean }, onboardingJourneyState?: { __typename?: 'OnboardingJourneyStateView', journeyId: string, progress: { __typename?: 'OnboardingJourneyProgress', scope: Array<{ __typename?: 'OnboardingJourneyScopeItem', family: string, status: Types.OnboardingJourneyScopeStatus }>, families: Array<{ __typename?: 'OnboardingJourneyFamilyProgress', family: string, selectedItemCount: number, completeItemCount: number, completeOperationCount: number }>, remainingWork: Array<{ __typename?: 'OnboardingJourneyOperationProgress', status: Types.OnboardingJourneyOperationStatus }>, nextActions: Array<{ __typename?: 'OnboardingJourneyNextAction', kind: Types.OnboardingJourneyNextActionKind }> }, questions: Array<{ __typename?: 'OnboardingJourneyQuestionEvidence', state: Types.OnboardingJourneyQuestionState }> } | null };

export type OnboardingWelcomePreferenceFragment = { __typename?: 'OnboardingWelcomePreference', snoozedUntil?: Types.TDateISO | null, isSnoozed: boolean, isDismissed: boolean };

export type GetMigrationReviewQueryVariables = Types.Exact<{
  journeyId: Types.Scalars['String']['input'];
}>;


export type GetMigrationReviewQuery = { __typename?: 'Query', migrationPreparationJobs: Array<{ __typename?: 'MigrationPreparationJobStatus', jobId: string, sourceId: string, sourceVersion: number, state: Types.MigrationPreparationJobState, rowsRead: number, rowsPrepared: number, blockingQuestions: number }>, migrationImportRuns: Array<{ __typename?: 'MigrationImportRunStatus', jobId: string, sourceId: string }>, migrationPendingReviews: Array<{ __typename?: 'MigrationPendingReview', presentationId: string, kind: Types.MigrationApprovalKind, subjectId: string, presentedAt: Types.TDateISO }>, onboardingJourneyState?: { __typename?: 'OnboardingJourneyStateView', journeyId: string, artifacts: Array<{ __typename?: 'OnboardingJourneyArtifactEvidence', artifactId: string, revision: number, jobId: string }>, questions: Array<{ __typename?: 'OnboardingJourneyQuestionEvidence', questionId: string, state: Types.OnboardingJourneyQuestionState }>, progress: { __typename?: 'OnboardingJourneyProgress', portions: Array<{ __typename?: 'OnboardingJourneyPortionProgress', portionId: string, artifactId: string, artifactRevision: number, run?: { __typename?: 'OnboardingJourneyRunProgress', runId: string } | null, operations: Array<{ __typename?: 'OnboardingJourneyOperationProgress', operationId: string, family: string, status: Types.OnboardingJourneyOperationStatus }> }>, remainingWork: Array<{ __typename?: 'OnboardingJourneyOperationProgress', operationId: string, portionId: string, family: string }> } } | null, tenant?: { __typename?: 'TenantStateData', onboardingUploads: Array<{ __typename?: 'TenantOnboardingUploadData', fileName: string, sourceId?: string | null, sourceVersion?: number | null }> } | null };

export type GetMigrationImportQuestionsQueryVariables = Types.Exact<{
  journeyId: Types.Scalars['String']['input'];
  sourceId: Types.Scalars['String']['input'];
  openOnly: Types.Scalars['Boolean']['input'];
  skip: Types.Scalars['Int']['input'];
  take: Types.Scalars['Int']['input'];
}>;


export type GetMigrationImportQuestionsQuery = { __typename?: 'Query', migrationImportQuestions: { __typename?: 'MigrationImportQuestionPage', total: number, questions: Array<{ __typename?: 'MigrationImportQuestionView', questionId: string, kind: Types.MigrationImportQuestionKind, blocking: boolean, text: string, affectedCount: number, current: boolean, open: boolean, options: Array<{ __typename?: 'MigrationImportQuestionOptionView', key: string, label: string, recordCount?: number | null }>, answer?: { __typename?: 'MigrationImportAnswerView', option: string, exceptions: Array<string>, applicable: boolean } | null, examples: Array<{ __typename?: 'MigrationPreparedRowView', row: string, file: string, sourceRows: Array<string>, fields: Array<{ __typename?: 'MigrationPreparedFieldView', name: string, value: string }> }> }> } };

export type GetMigrationPreparedRowsQueryVariables = Types.Exact<{
  journeyId: Types.Scalars['String']['input'];
  sourceId: Types.Scalars['String']['input'];
  skip: Types.Scalars['Int']['input'];
  take: Types.Scalars['Int']['input'];
}>;


export type GetMigrationPreparedRowsQuery = { __typename?: 'Query', migrationPreparedRows: { __typename?: 'MigrationPreparedRowPage', revisionNumber: number, total: number, expired: boolean, rows: Array<{ __typename?: 'MigrationPreparedRowView', row: string, file: string, sourceRows: Array<string>, fields: Array<{ __typename?: 'MigrationPreparedFieldView', name: string, value: string }> }> } };

export type MigrationPreparedRowFragment = { __typename?: 'MigrationPreparedRowView', row: string, file: string, sourceRows: Array<string>, fields: Array<{ __typename?: 'MigrationPreparedFieldView', name: string, value: string }> };

export type OnboardingUploadFragment = { __typename?: 'TenantOnboardingUploadData', fileName: string, sourceId?: string | null, sourceVersion?: number | null };

export const OnboardingWelcomePreferenceFragmentDoc = new TypedDocumentString(`
    fragment OnboardingWelcomePreference on OnboardingWelcomePreference {
  snoozedUntil
  isSnoozed
  isDismissed
}
    `, {"fragmentName":"OnboardingWelcomePreference"});
export const MigrationPreparedRowFragmentDoc = new TypedDocumentString(`
    fragment MigrationPreparedRow on MigrationPreparedRowView {
  row
  file
  sourceRows
  fields {
    name
    value
  }
}
    `, {"fragmentName":"MigrationPreparedRow"});
export const OnboardingUploadFragmentDoc = new TypedDocumentString(`
    fragment OnboardingUpload on TenantOnboardingUploadData {
  fileName
  sourceId
  sourceVersion
}
    `, {"fragmentName":"OnboardingUpload"});
export const GetOnboardingJourneyFilesDocument = new TypedDocumentString(`
    query GetOnboardingJourneyFiles {
  onboardingJourneyLookup {
    exists
    unfinished
    journeyId
    sessionReference
  }
  onboardingJourneyState {
    journeyId
    jobs {
      jobId
      sourceId
      sourceVersion
      state
    }
  }
  onboardingJourneyOutsideUploads {
    fileName
    sourceId
    sourceVersion
    uploadedAt
  }
  tenant {
    onboardingUploads {
      ...OnboardingUpload
      importedAt
      occurredAt
      reviewAreas
    }
  }
}
    fragment OnboardingUpload on TenantOnboardingUploadData {
  fileName
  sourceId
  sourceVersion
}`);
export const GetOnboardingWelcomeDocument = new TypedDocumentString(`
    query GetOnboardingWelcome {
  tenant {
    onboardingSetup
    onboardingTraining
    contractedProducts
  }
  onboardingJourneyLookup {
    exists
    unfinished
    journeyId
  }
  myOnboardingWelcomePreference {
    ...OnboardingWelcomePreference
  }
  onboardingJourneyState {
    journeyId
    progress {
      scope {
        family
        status
      }
      families {
        family
        selectedItemCount
        completeItemCount
        completeOperationCount
      }
      remainingWork {
        status
      }
      nextActions {
        kind
      }
    }
    questions {
      state
    }
  }
}
    fragment OnboardingWelcomePreference on OnboardingWelcomePreference {
  snoozedUntil
  isSnoozed
  isDismissed
}`);
export const GetMigrationReviewDocument = new TypedDocumentString(`
    query GetMigrationReview($journeyId: String!) {
  migrationPreparationJobs(journeyId: $journeyId) {
    jobId
    sourceId
    sourceVersion
    state
    rowsRead
    rowsPrepared
    blockingQuestions
  }
  migrationImportRuns(journeyId: $journeyId) {
    jobId
    sourceId
  }
  migrationPendingReviews(journeyId: $journeyId) {
    presentationId
    kind
    subjectId
    presentedAt
  }
  onboardingJourneyState {
    journeyId
    artifacts {
      artifactId
      revision
      jobId
    }
    questions {
      questionId
      state
    }
    progress {
      portions {
        portionId
        artifactId
        artifactRevision
        run {
          runId
        }
        operations {
          operationId
          family
          status
        }
      }
      remainingWork {
        operationId
        portionId
        family
      }
    }
  }
  tenant {
    onboardingUploads {
      ...OnboardingUpload
    }
  }
}
    fragment OnboardingUpload on TenantOnboardingUploadData {
  fileName
  sourceId
  sourceVersion
}`);
export const GetMigrationImportQuestionsDocument = new TypedDocumentString(`
    query GetMigrationImportQuestions($journeyId: String!, $sourceId: String!, $openOnly: Boolean!, $skip: Int!, $take: Int!) {
  migrationImportQuestions(
    journeyId: $journeyId
    sourceId: $sourceId
    openOnly: $openOnly
    skip: $skip
    take: $take
  ) {
    total
    questions {
      questionId
      kind
      blocking
      text
      options {
        key
        label
        recordCount
      }
      affectedCount
      current
      open
      answer {
        option
        exceptions
        applicable
      }
      examples {
        ...MigrationPreparedRow
      }
    }
  }
}
    fragment MigrationPreparedRow on MigrationPreparedRowView {
  row
  file
  sourceRows
  fields {
    name
    value
  }
}`);
export const GetMigrationPreparedRowsDocument = new TypedDocumentString(`
    query GetMigrationPreparedRows($journeyId: String!, $sourceId: String!, $skip: Int!, $take: Int!) {
  migrationPreparedRows(
    journeyId: $journeyId
    sourceId: $sourceId
    skip: $skip
    take: $take
  ) {
    revisionNumber
    total
    expired
    rows {
      ...MigrationPreparedRow
    }
  }
}
    fragment MigrationPreparedRow on MigrationPreparedRowView {
  row
  file
  sourceRows
  fields {
    name
    value
  }
}`);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetOnboardingJourneyFiles: build.query<GetOnboardingJourneyFilesQuery, GetOnboardingJourneyFilesQueryVariables | void>({
      query: (variables) => ({ document: GetOnboardingJourneyFilesDocument, variables })
    }),
    GetOnboardingWelcome: build.query<GetOnboardingWelcomeQuery, GetOnboardingWelcomeQueryVariables | void>({
      query: (variables) => ({ document: GetOnboardingWelcomeDocument, variables })
    }),
    GetMigrationReview: build.query<GetMigrationReviewQuery, GetMigrationReviewQueryVariables>({
      query: (variables) => ({ document: GetMigrationReviewDocument, variables })
    }),
    GetMigrationImportQuestions: build.query<GetMigrationImportQuestionsQuery, GetMigrationImportQuestionsQueryVariables>({
      query: (variables) => ({ document: GetMigrationImportQuestionsDocument, variables })
    }),
    GetMigrationPreparedRows: build.query<GetMigrationPreparedRowsQuery, GetMigrationPreparedRowsQueryVariables>({
      query: (variables) => ({ document: GetMigrationPreparedRowsDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetOnboardingJourneyFilesQuery, useLazyGetOnboardingJourneyFilesQuery, useGetOnboardingWelcomeQuery, useLazyGetOnboardingWelcomeQuery, useGetMigrationReviewQuery, useLazyGetMigrationReviewQuery, useGetMigrationImportQuestionsQuery, useLazyGetMigrationImportQuestionsQuery, useGetMigrationPreparedRowsQuery, useLazyGetMigrationPreparedRowsQuery } = injectedRtkApi;
